import { mapGetters, mapActions } from 'vuex'
import siteTab from '@/components/tab'
export default {
  components: {
    siteTab
  },
  data() {
    return {
      menus: [
        {
          name: 'Manuscript',
          href: '/statistic/data/manuscript',
          code: 'STATISTICS.DATA_REPORT.MANUSCRIPT_STATISTICS'
        },
        {
          name: 'Article',
          href: '/statistic/data/article',
          code: 'STATISTICS.DATA_REPORT.ARTICLE_STATISTICS'
        },
        {
          name: 'Special Issue',
          href: '/statistic/data/special',
          code: 'STATISTICS.DATA_REPORT.SPECIAL_ISSUE_STATISTICS'
        },
        {
          name: 'Reviewers',
          href: '/statistic/data/reviewer',
          code: 'STATISTICS.DATA_REPORT.REVIEWERS_STATISTICS'
        },
        {
          name: 'Other Reports',
          href: '/statistic/data/export',
          code: 'STATISTICS.DATA_REPORT.OTHER_REPORTS'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage',
      journalId: 'getJournalId'
    })
  },
  watch: {
    user: {
      handler() {
        this.redict()
      },
      immediate: true
    },
    $route() {
      this.redict()
    }
  },
  methods: {
    ...mapActions(['updateJournalId', 'updatePersonalJournalList']),
    redict() {
      if (this.$route.path !== '/statistic/data') {
        return
      }
      this.menus.some(item => {
        if (this.user.codeList && this.user.codeList.includes(item.code)) {
          this.$router.replace(item.href)
          return true
        }
      })
    }
  }
}
